import { UserService } from '@app/core/user/services/user/user.service';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Logger } from '@app/core/logging';
import { Subject } from 'rxjs';
import { PopinAuthShowed } from '@app/core/user/store/actions';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';

@Component({
  selector: 'vc-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordResetComponent implements OnInit {
  @Input()
  currentEmail: string;
  @Input()
  popinForced: boolean;
  @Output()
  displayResetPassword = new EventEmitter<boolean>();

  public pending = new Subject();
  public error: string;
  public errorMsg = '';
  public submitted = new Subject();

  public resetPasswordForm: FormGroup;

  public isMobile = false;

  constructor(
    private userService: UserService,
    private store: Store<IAppState>,
    private logger: Logger,
    private fb: FormBuilder,
    private helperService: HelpersService
  ) {}

  ngOnInit() {
    this.pending.next(false);
    this.submitted.next(false);
    this.resetPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(`^[\\w.-]+(\\+[\\w.-]+)?@[\\w.-]+\\.[a-zA-Z]{2,6}$`)]]
    });
    this.resetPasswordForm.patchValue({
      email: this.currentEmail
    });
    this.isMobile = !this.helperService.device.isMdUp();
    this.store.dispatch(
      new PopinAuthShowed({
        type: 'password',
        forced: this.popinForced,
        isMobile: this.isMobile
      })
    );
  }

  resetPassword() {
    this.pending.next(true);
    this.userService.resetUserPassword(this.resetPasswordForm.get('email').value).subscribe(
      res => {
        this.pending.next(false);
        this.submitted.next(true);
      },
      error => {
        this.pending.next(false);
        this.displayError(error.error.errors.detail);
        this.logger.error('[USER] resetPassword:' + error.message);
      }
    );
  }
  displayError(errormsg) {
    this.errorMsg = errormsg;
    this.resetPasswordForm.get('email').setErrors({ unknownEmail: true });
  }

  continueAfterConfirmation() {
    this.displayResetPassword.emit(false);
  }

  onEmailFocusOut() {
    if (this.resetPasswordForm.get('email').value.length === 0) {
      this.resetPasswordForm.get('email').reset();
    }
  }
}
